import { EventData } from './contracts';

const sendFetch = (url: string, data: EventData, options?: RequestInit) => {
  fetch(url, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify(data),
    keepalive: options?.keepalive,
  }).catch(error => {
    console.log(`Error: ${error}`);
  });
};

export default sendFetch;
